<template lang="pug">
section.app-main(:style='[hiddenSidebarStyle]')
  .container.is-fluid.is-marginless.app-content
    levelbar
    transition(mode='out-in' enter-active-class='fadeIn' leave-active-class='fadeOut' appear='')
      router-view.animated
</template>

<script>
import Levelbar from './Levelbar'

export default {
  computed: {
    sidebar () {
      return this.$store.state.app.sidebar
    },
    hiddenSidebarStyle () {
      return this.sidebar.hidden ? { 'margin-left': 0 } : null
    }
  },

  components: {
    Levelbar
  }
}
</script>

<style lang="scss">
@import '~bulma/sass/utilities/initial-variables';
@import '~bulma/sass/utilities/derived-variables';
@import '~bulma/sass/utilities/mixins';

.app-main {
  margin-left: 180px;
  transform: translate3d(0, 0, 0);

  @include mobile() {
    margin-left: 0;
  }

}

.app-content {
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// AppMain.vue?bd9f36cc